import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BlogPreview from "../components/BlogPreview";
import IntroSection from "../components/IntroSection";  

const images = [
  "/images/1.jpg",
  "/images/2.jpg",
  "/images/3.jpg",
  "/images/4.jpg",
  "/images/5.jpg",
  "/images/6.jpg",
  "/images/7.jpg",
];

export default function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [posts, setPosts] = useState([]);
  const [servicePosts, setServicePosts] = useState([]);
  const timeoutRef = useRef(null);
  const sliderRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const currentTranslate = useRef(0);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const mapRef = useRef(null);
  const centerLat = 37.7472333;
  const centerLng = 127.1192456;

  // 사진 눌렀을 때 이동
  const handleFacilityClick = () => {
    navigate("/about?tab=facility");
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0); // navigate 직후 다음 이벤트루프로 scroll
  };
  // 슬라이드
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const zoomButtonStyle = {
    display: "block",
    width: "40px",
    height: "40px",
    marginBottom: "5px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    fontSize: "20px",
    cursor: "pointer",
    borderRadius: "4px",
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=h81wnw69gd`;
    script.async = true;
    script.onload = () => {
      const center = new window.naver.maps.LatLng(centerLat, centerLng);
      const map = new window.naver.maps.Map(mapRef.current, {
        center: center,
        zoom: 16,
        zoomControl: false, // 기본 zoom 버튼 비활성화
      });
      map.setCenter(center);

      new window.naver.maps.Marker({
        position: center,
        map: map,
      });

      // 커스텀 줌 버튼 기능 연결
      const zoomInBtn = document.getElementById("zoom-in");
      const zoomOutBtn = document.getElementById("zoom-out");

      if (zoomInBtn && zoomOutBtn) {
        zoomInBtn.onclick = () => map.setZoom(map.getZoom() + 1);
        zoomOutBtn.onclick = () => map.setZoom(map.getZoom() - 1);
      }
    };
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4500);
    return () => resetTimeout();
  }, [currentIndex]);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.clientX;
  };
  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const delta = e.clientX - startX.current;
    currentTranslate.current = delta;
  };
  const handleMouseUp = () => {
    if (currentTranslate.current > 100 && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else if (
      currentTranslate.current < -100 &&
      currentIndex < images.length - 1
    ) {
      setCurrentIndex(currentIndex + 1);
    }
    isDragging.current = false;
    currentTranslate.current = 0;
  };

  // 게시글 불러오기
  useEffect(() => {
    axios.get(`${baseUrl}/api/blog/latest`).then((res) => setPosts(res.data));
    axios.get(`${baseUrl}/api/board`).then((res) => setServicePosts(res.data));
  }, [baseUrl]);

  return (
    <div className="flex flex-col">
      {/* 상단 슬라이더 */}
      <section className="w-full h-[60vh] sm:h-screen overflow-hidden relative">
        <div
          className="relative w-full h-[50vh] sm:h-[100vh] overflow-hidden"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          ref={sliderRef}>
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {images.map((img, i) => (
              <div
                key={i}
                className="w-full flex-shrink-0 h-[50vh] sm:h-screen bg-center bg-cover"
                style={{ backgroundImage: `url(${img})` }}
              />
            ))}
          </div>

          {/* 좌우 버튼 */}
          <button
            onClick={() =>
              setCurrentIndex(
                (currentIndex - 1 + images.length) % images.length
              )
            }
            className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white/70 hover:bg-white px-3 py-1 rounded">
            ‹
          </button>
          <button
            onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white/70 hover:bg-white px-3 py-1 rounded">
            ›
          </button>

          {/* 중앙 마크 */}
          <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
            <img
              src="/images/center-mark.png"
              alt="마크"
              className="w-24 h-24 sm:w-32 sm:h-32 rounded-full border-4 border-white shadow-xl"
            />
            <h1 className="text-white text-xl mt-4 font-bold">
              아이엠플러스 <br />교육심리센터
            </h1>
          </div>
        </div>
      </section>

      {/* 센터소개 안내문 */}
      <IntroSection />

      <section style={{ padding: "40px 20px", backgroundColor: "#fff" }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}>
            <h2 style={{ fontSize: "20px", color: "#98bcc9", margin: 0 }}>
              시설안내
            </h2>
          </div>

          <div
            style={{
              height: "1px",
              backgroundColor: "#eee",
              marginBottom: "30px",
            }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {[
              "/images/aboutImg1.jpeg",
              "/images/aboutImg2.jpeg",
              "/images/aboutImg3.jpeg",
              "/images/aboutImg4.jpeg",
              "/images/aboutImg5.jpeg",
              "/images/aboutImg6.jpeg",
              "/images/aboutImg7.jpeg",
              "/images/aboutImg8.jpeg",
              "/images/aboutImg9.jpeg",
              "/images/aboutImg10.jpeg",
            ].map((src, idx) => (
              <div
                key={idx}
                onClick={handleFacilityClick}
                className="cursor-pointer">
                <img
                  src={src}
                  alt={`시설 이미지 ${idx + 1}`}
                  className="w-full h-72 object-cover rounded-xl shadow"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 치료 프로그램 섹션 */}
      {/* 사이트에서 현재 사용 x
      <section style={{ padding: "60px 20px", backgroundColor: "#fff" }}> 
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}>
            <h2 style={{ fontSize: "20px", color: "#98bcc9", margin: 0 }}>
              게시판
            </h2>
            <button
              onClick={() => navigate("/services")}
              style={{
                fontSize: "14px",
                color: "#333",
                textDecoration: "none",
                fontWeight: "bold",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}>
              더보기 &gt;
            </button>
          </div>

          <div
            style={{
              height: "1px",
              backgroundColor: "#eee",
              marginBottom: "30px",
            }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 cursor-pointer">
            {servicePosts.length > 0 ? (
              servicePosts.slice(0, 3).map((post) => (
                <div
                  key={post.board_number}
                  className="w-full max-w-xs mx-auto border shadow-none hover:shadow-xl p-4 transition-shadow duration-200 flex flex-col h-auto min-h-[180px]"
                  onClick={() => navigate(`/board/${post.board_number}`)}>
                  <h3 className="font-semibold text-lg mb-2 truncate">
                    {post.title}
                  </h3>

                  {post.content && (
                    <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                      {post.content.slice(0, 100) + "..."}
                    </p>
                  )}

                  <p className="text-sm text-gray-500 mt-auto">
                    {post.date || ""}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-500">로딩 중입니다...</p>
            )}
          </div>
        </div>
      </section>
      */}      
      {/* SNS 소식 */}
      <section style={{ padding: "60px 20px", backgroundColor: "#fff" }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          {/* 제목 + 더보기 버튼 한 줄 */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}>
            <h2 style={{ fontSize: "20px", color: "#98bcc9", margin: 0 }}>
              SNS 소식
            </h2>
            <button
              onClick={() => navigate("/sns")}
              style={{
                fontSize: "14px",
                color: "#333",
                textDecoration: "none",
                fontWeight: "bold",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}>
              더보기 &gt;
            </button>
          </div>

          {/* 구분선 */}
          <div
            style={{
              height: "1px",
              backgroundColor: "#eee",
              marginBottom: "30px",
            }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {posts.length > 0 ? (
              posts.slice(0, 3).map((post, idx) => (
                <div
                  key={idx}
                  className="w-full max-w-[360px] mx-auto md:max-w-none" // 모바일에서만 작게
                >
                  <BlogPreview blogUrl={post.link} />
                </div>
              ))
            ) : (
              <p className="text-gray-500">로딩 중입니다...</p>
            )}
          </div>
        </div>
      </section>

      {/* 오시는길 섹션 */}
      <section style={{ padding: "60px 20px", backgroundColor: "#fff" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxWidth: "1000px",
            margin: "30px auto 10px",
          }}>
          <h2
            style={{
              fontSize: "20px",
              color: "#98bcc9",
              margin: 0,
            }}>
            오시는길
          </h2>
          <a
            href="/location"
            style={{
              fontSize: "14px",
              color: "#333",
              textDecoration: "none",
              fontWeight: "bold",
            }}>
            더보기 &gt;
          </a>
        </div>

        {/* 밑에 구분선 */}
        <div
          style={{
            height: "1px",
            backgroundColor: "#eee",
            marginBottom: "30px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}></div>
        {/* 지도 */}
        <div
          ref={mapRef}
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "1000px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
            border: "1px solid #eee",
            margin: "0 auto 40px",
          }}>
          {/* 안내 텍스트 */}
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "rgba(255,255,255,0.9)",
              padding: "6px 10px",
              borderRadius: "4px",
              fontSize: "13px",
              color: "#444",
              fontWeight: "bold",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              zIndex: 30,
            }}>
            지도가 포커스되면 방향키로 이동할 수 있습니다
          </div>
        </div>
        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "1000px",
            margin: "0 auto",
          }}>
          <div
            style={{
              position: "absolute",
              right: "10px",
              bottom: "60px",
              zIndex: 30,
            }}>
            <button id="zoom-in" style={zoomButtonStyle}>
              +
            </button>
            <button id="zoom-out" style={zoomButtonStyle}>
              −
            </button>
          </div>
        </div>

        {/* 센터 정보 */}
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{ marginBottom: "30px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "20px",
              }}>
              <div style={{ color: "#666" }}>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}>
                  아이엠플러스교육심리센터
                </div>
                <div style={{ color: "#98bcc9", fontSize: "25px" }}>
                  경기도 의정부시 배꽃길 105.더리브센텀스퀘어 1동 9층 904호
                </div>
              </div>
              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <a
                  href="https://map.naver.com/v5/directions/-/14147564.928852385,4529956.944925289,아이엠플러스교육심리센터,1378305522,PLACE_POI/-/walk"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#98bcc9",
                    padding: "10px 20px",
                    borderRadius: "0px",
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  길찾기
                </a>
                <a
                  href="https://map.naver.com/v5/search/경기도 의정부시 배꽃길 105 1동 9층 904호"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#98bcc9",
                    padding: "10px 20px",
                    borderRadius: "0px",
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}>
                  지도에서 보기
                </a>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "20px",
                color: "#333",
                borderTop: "1px solid #eee",
                paddingTop: "25px",
              }}>
              <div className="flex items-start gap-2">
                <div className="text-[20px]">
                  <img
                    src="/images/cellphone-icon.png"
                    alt="전화 아이콘"
                    width={20}
                    height={20}
                  />
                </div>
                <div>
                  <div className="font-bold mb-1">전화번호</div>

                </div>

                <div className="flex flex-col ml-14">
                  <div>031-928-7329</div>
                  <div>010-2989-1713</div>
                </div>
              </div>
            </div>

            {/* 전화번호 */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: "20px",
                borderTop: "1px solid #eee",
                marginTop: "30px",
                paddingTop: "20px",
              }}
            >

              {/* 이용안내 텍스트 */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "#444",
                  minWidth: "100px",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontSize: "18px" }}>
                  <img
                    src="/images/exclamation-icon.png"
                    alt="느낌표 아이콘"
                    width={20}
                    height={20}
                  />
                </span>
                이용안내
              </div>

              {/* 아이콘 목록 */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  justifyContent: "flex-start",
                  flex: "1",
                }}
              >
                {[
                  {
                    icon: (
                      <img
                        src="/images/calendar-icon.png"
                        alt="예약 아이콘"
                        width={40}
                        height={40}
                      />
                    ),
                    label: "예약",
                  },
                  {
                    icon: (
                      <img
                        src="/images/parkingcar-icon.png"
                        alt="주차 아이콘"
                        width={40}
                        height={40}
                      />
                    ),
                    label: "주차",
                  },
                  {
                    icon: (
                      <img
                        src="/images/wirelessNetwork-icon.png"
                        alt="무선 아이콘"
                        width={40}
                        height={40}
                      />
                    ),
                    label: "무선 인터넷",
                  },
                  {
                    icon: (
                      <img
                        src="/images/toilet-icon.png"
                        alt="화장실 아이콘"
                        width={40}
                        height={40}
                      />
                    ),
                    label: "남/녀 화장실 구분",
                  },
                ].map(({ icon, label }) => (
                  <div
                    key={label}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      minWidth: "100px",
                    }}
                  >
                    <div style={{ marginBottom: "6px" }}>{icon}</div>
                    <div style={{ fontSize: "14px", color: "#444" }}>{label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}
